import React from 'react';
import { View, Text, StyleSheet, ActivityIndicator } from 'react-native';
import i18n from 'i18n-js';

import { scale as initialScale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import { font as initialFont } from '@styles/fonts';
import { isWeb } from '@helpers';

export default ({
  C,
  items: fullList = [],
  font = initialFont,
  scale = initialScale,
  borderRadius = 12,
  minWidth,
  boxShadow,
  bg = 'Background/Light/Field',
}) => {
  const items = fullList.filter((i) => !i.hide);

  const boxShadowStyles = boxShadow ?? {
    boxShadow: `
      0px 0px 160px 0px #00000040,
      0px 2.4px 14.4px 0px #00000005,
      0px 4px 4px 0px #00000005
    `,
  };

  return (
    <View
      style={[
        {
          borderRadius: scale(borderRadius),
          ...boxShadowStyles,
        },
        minWidth && { minWidth: scale(minWidth) },
      ]}
    >
      {items.map((i, index) => {
        const iconsBlockWidth = i?.icon ? i.icon.width : i?.icons ? i.icons.reduce((acc, icon) => acc + icon.width + (i?.iconsGap ?? 0), 0) : 0;

        const paddingVertical = i?.style?.paddingVertical != null ? i.style.paddingVertical : i.subtitle ? 0 : 9;
        const paddingHorizontal = i?.style?.paddingHorizontal != null ? i?.style.paddingHorizontal : i.subtitle ? 10 : 15;

        return (
          <TouchableElement testID={i.testID} hitSlop={{ top: 0, bottom: 0, left: 0, right: 0 }} onPress={() => (i.onPress ? i.onPress() : null)} key={index}>
            {({ boxStyle, pressHoverColor }) => (
              <View
                style={[
                  boxStyle,
                  {
                    height: i.subtitle ? scale(20) : i.divideSection ? scale(46) : scale(41),
                    paddingTop: scale(paddingVertical),
                    paddingBottom: scale(paddingVertical),
                    paddingHorizontal: scale(paddingHorizontal),
                    backgroundColor: i.subtitle ? 'transparent' : C(pressHoverColor(bg)),
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    alignContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                  },
                  index === 0 && {
                    borderTopLeftRadius: scale(borderRadius),
                    borderTopRightRadius: scale(borderRadius),
                  },
                  index === items.length - 1 && {
                    borderBottomLeftRadius: scale(borderRadius),
                    borderBottomRightRadius: scale(borderRadius),
                  },
                  index !== 0 && {
                    borderRadius: 0,
                    height: i.subtitle ? scale(20) : i.divideSection ? scale(46) : scale(41),
                  },
                  isWeb && { cursor: 'pointer' },
                ]}
              >
                {index !== 0 && !i.subtitle && !items[index - 1]?.subtitle && (
                  <View
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: scale(i.subtitle ? 10 : 15),
                      right: scale(i.subtitle ? 10 : 15),
                      height: i.divideSection ? scale(5) : StyleSheet.hairlineWidth,
                      backgroundColor: C('Hairline/Light/No trans'),
                    }}
                  />
                )}
                <View
                  style={[
                    i.subtitle && {
                      backgroundColor: C('Fill/Light/Tertiary'),
                      paddingHorizontal: scale(5),
                      paddingTop: scale(4),
                      paddingBottom: scale(4),
                      borderRadius: scale(2),
                      flex: 1,
                    },
                  ]}
                >
                  <Text style={[i?.lable?.font != null ? i.lable.font : i.subtitle ? font['Button 3'] : font.Body, { color: C(i.lable?.color) }]}>
                    {i18n.t(i.lable?.name)}
                  </Text>
                </View>
                {!i.subtitle && (i.icon || i.icons) && (
                  <View style={[{ marginLeft: scale(18), width: scale(iconsBlockWidth), alignItems: 'flex-end' }]}>
                    {i.isLoading ? (
                      <ActivityIndicator size="small" color="#777777" />
                    ) : (
                      <>
                        {i?.icon && (
                          <Svg
                            icon={i.icon.name}
                            width={scale(i.icon.width)}
                            height={scale(i.icon.height)}
                            color={i.icon.color}
                            key={scale(i.icon.width)}
                            {...(i?.icon?.transform ? { transform: i.icon.transform } : {})}
                          />
                        )}
                        {i?.icons && (
                          <View style={{ flexDirection: 'row', gap: scale(i?.iconsGap ?? 0), alignItems: 'center' }}>
                            {i?.icons.map((icon) => (
                              <Svg
                                icon={icon.name}
                                width={scale(icon.width)}
                                height={scale(icon.height)}
                                color={icon.color}
                                key={icon.name}
                                {...(icon?.transform ? { transform: icon.transform } : {})}
                              />
                            ))}
                          </View>
                        )}
                      </>
                    )}
                  </View>
                )}
              </View>
            )}
          </TouchableElement>
        );
      })}
    </View>
  );
};
